module.exports = __webpack_public_path__ + "img/im_scrollfeature_08@2x.74953084.jpg";